import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showRouterBar:false,
    showBreadcrumb:false,
    showFooter:false,
    isShow:false,
    showHeader: false,
    certVisible: false,
  },
  mutations: {
    // 首页页脚
    changeshowFooterState(state,value){
      state.showFooter = value
    },
    // header
    changeshowHeaderState(state,value){
      state.showHeader = value
    },
    // 面包屑显示/隐藏状态
    changeShowBreadcrumbState(state,value){
      state.showBreadcrumb = value
    },
    // 路由组件显示/隐藏状态
    changeShowshowRouterBarState(state,value){
      state.showRouterBar = value
    },
    // 控制弹窗显示隐藏
    changeDialogShow(state,value){
      state.isShow = value
    },
    // 控制实名认证弹窗显示隐藏
    changeCertVisibleState(state,value){
      state.certVisible = value
    }
  },
  actions: {},
  modules: {}
});
